module.exports = __webpack_public_path__ + "img/avatar.23bbecfe.png";